(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvMonitorShareStatus', ['$http', function($http) {
    var taskMap = {};

    var getRandomInt = function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    var getTaskId = function(taskMap) {
      var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var id = '';
      for (var i = 0; i < 3; i++) {
        var randomIdx = getRandomInt(0, chars.length - 1);
        id += chars[randomIdx];
      }

      if (taskMap[id]) {
        return getTaskId(taskMap);
      } else {
        return id;
      }
    };

    function Task(id, shareType, shareBtnClickedTime, sns, quizId, meaningId) {
      this.id = id;
      this.sns = sns;
      this.shareType = shareType;
      this.shareBtnClickedTime = shareBtnClickedTime;
      this.quizId = quizId;
      this.meaningId = meaningId;
    }

    Task.prototype.report = function(data) {
      var url = '/api/monitor/share_status';
      var params = {};
      params.sns = this.sns;
      params.share_type = this.shareType;
      params.status = data.status;
      params.response_time = data.response_time;
      params.quiz_id = this.quizId;
      params.meaning_id = this.meaningId;

      if (!url)
      return;
      $http.post(url, params);
      console.log('vvMonitorShareStatus(' + this.id + ') : Report share_status', params);
    };

    this.generateTask = function(sns, shareType, quizId, meaningId) {
      if (['result'].indexOf(shareType) < 0)
      return;
      var taskId = getTaskId(taskMap);
      var task = new Task(taskId, shareType, new Date(), sns, quizId, meaningId);
      taskMap[task.id] = task;
      console.log('vvMonitorShareStatus(' + taskId + ') : Generate a Monitor Task');

      var data = {
        'status': 'request',
      };
      task.report(data);
      return task.id;
    };

    this.notify = function(taskId, status) {
      console.log('vvMonitorShareStatus(' + taskId + ') : Share Response Arrived : ' + status);
      var task = taskMap[taskId];
      if (!task)
      return;

      var now = new Date().getTime();
      var responseTime = now - task.shareBtnClickedTime.getTime();

      var data = null;
      if (status == 'success' || status == 'fail_but_responded') {
        data = {
          'status': status,
          'response_time' : responseTime,
        };
      }

      if (!data)
      return;
      task.report(data);
    };
  }]);
})(window, window.angular);
